<div class="modern-admin-page">
  <!-- Page Header -->
  <div class="page-header-card">
    <div class="header-content">
      <div class="page-title-section">
        <h1 class="page-title bangla-heading">কর আদায়</h1>
        <p class="page-subtitle bangla-text">এ্যাসেসমেন্ট অনুযায়ী কর আদায় করুন</p>
      </div>
      <div class="page-actions">
        <button type="button" class="btn-secondary-modern" routerLink="/admin/tax-collection-list">
          <i class="fas fa-list"></i>
          কর তালিকা
        </button>
      </div>
    </div>
  </div>

  <!-- Assessment Details Section -->
  <div class="content-card slide-up">
    <div class="card-header">
      <h3 class="card-title bangla-title">
        <i class="fas fa-user-circle"></i>
        এ্যাসেসমেন্ট বিস্তারিত
      </h3>
      <div class="card-actions">
        <div class="qr-code-badge" *ngIf="qrCode">
          <i class="fas fa-qrcode"></i>
          QR: {{qrCode}}
        </div>
      </div>
    </div>
    
    <div class="card-body">
      <div class="assessment-grid">
        <div class="assessment-item">
          <div class="item-label bangla-label">ওয়ার্ড নং</div>
          <div class="item-value ward-number">
            <span class="ward-badge bangla-text">{{unionDomain.convertEnglishHoldingNumberToBanglaHoldingNumber(assessment.ward_number.toString())}}</span>
          </div>
        </div>
        
        <div class="assessment-item">
          <div class="item-label bangla-label">হোল্ডিং নং</div>
          <div class="item-value holding-number bangla-text">{{assessment.holding_number}}</div>
        </div>
        
        <div class="assessment-item">
          <div class="item-label bangla-label">নাম</div>
          <div class="item-value name bangla-text">{{assessment.name}}</div>
        </div>
        
        <div class="assessment-item">
          <div class="item-label bangla-label">পিতা/স্বামী</div>
          <div class="item-value guardian bangla-text">{{assessment.gurdian_name}}</div>
        </div>
        
        <div class="assessment-item">
          <div class="item-label bangla-label">মোবাইল নং</div>
          <div class="item-value mobile">
            <i class="fas fa-phone"></i>
            <span class="bangla-text">{{assessment.mobile_number}}</span>
          </div>
        </div>
        
        <div class="assessment-item">
          <div class="item-label bangla-label">গ্রাম/রাস্তা</div>
          <div class="item-value address bangla-text">{{assessment.gram_or_rasta}}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Tax Collection Form -->
  <div class="content-card slide-up">
    <div class="card-header">
      <h3 class="card-title bangla-title">
        <i class="fas fa-plus-circle"></i>
        কর আদায় ফরম
      </h3>
    </div>
    
    <div class="card-body">
      <form *ngIf="taxForm" [formGroup]="taxForm" (ngSubmit)="onSubmit()" class="modern-form">
        <div class="form-row">
          <div class="form-group">
            <label class="form-label bangla-label required">অর্থবছর *</label>
            <select formControlName="financial_year" class="form-control-modern" required (change)="onFinancialYearChange()">
              <option value="" disabled>অর্থবছর নির্বাচন করুন</option>
              <option *ngFor="let year of yearList" [value]="year">
                {{year}}-{{Number(year)+1}}
              </option>
            </select>
          </div>
          
          <div class="form-group">
            <label class="form-label bangla-label required">কর *</label>
            <input 
              type="number" 
              formControlName="amount" 
              class="form-control-modern" 
              placeholder="১০০" 
              required>
            <div *ngIf="outstandingAmount > 0" class="form-help-text bangla-text">
              <i class="fas fa-info-circle"></i>
              মোট বকেয়া কর: {{ outstandingAmount }} টাকা (সব বছর মিলিয়ে)
            </div>
            <div *ngIf="outstandingAmount === 0" class="form-help-text success bangla-text">
              <i class="fas fa-check-circle"></i>
              সকল কর পরিশোধিত (সব বছর মিলিয়ে)
            </div>
            <div *ngIf="outstandingAmount < 0" class="form-help-text warning bangla-text">
              <i class="fas fa-exclamation-circle"></i>
              অতিরিক্ত পরিশোধ: {{ Math.abs(outstandingAmount) }} টাকা
            </div>
          </div>
          
          <div class="form-group">
            <label class="form-label bangla-label required">আদায়/বরাদ্দ *</label>
            <select formControlName="debit_credit" class="form-control-modern">
              <option value="C">বরাদ্দ</option>
              <option value="D">আদায়</option>
            </select>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-primary-modern bangla-text">
            <i class="fas fa-save"></i>
            দাখিল করুন
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Tax Collection List -->
  <div class="content-card slide-up">
    <div class="card-header">
      <h3 class="card-title bangla-title">
        <i class="fas fa-list-alt"></i>
        কর আদায় তালিকা
      </h3>
      <div class="card-actions">
        <span class="data-count bangla-text">
          মোট <strong>{{ taxList?.length || 0 }}</strong> টি রেকর্ড
        </span>
      </div>
    </div>

    <div class="card-body">
      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-state">
        <div class="loading-spinner">
          <i class="fas fa-spinner fa-spin"></i>
          <p class="bangla-text">ডেটা লোড হচ্ছে...</p>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoading && (!taxList || taxList.length === 0)" class="empty-state">
        <div class="empty-icon">
          <i class="fas fa-receipt"></i>
        </div>
        <h3 class="bangla-title">কোনো কর আদায়ের রেকর্ড পাওয়া যায়নি</h3>
        <p class="bangla-text">এই এ্যাসেসমেন্টের জন্য এখনো কোনো কর আদায় করা হয়নি। উপরের ফর্ম ব্যবহার করে প্রথম কর আদায় করুন।</p>
      </div>

      <!-- Data Table -->
      <div *ngIf="!isLoading && taxList && taxList.length > 0" class="table-responsive">
        <table class="table-modern" role="table" aria-label="কর আদায় তালিকা">
          <thead>
            <tr role="row">
              <th role="columnheader" class="bangla-label">অর্থবছর</th>
              <th role="columnheader" class="bangla-label">কর</th>
              <th role="columnheader" class="bangla-label">আদায়/বরাদ্দ</th>
              <th role="columnheader" class="bangla-label">তারিখ</th>
              <th role="columnheader" class="actions-column bangla-label">কার্যক্রম</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tax of taxList; trackBy: trackByTaxId; let i = index" [class.table-striped]="i % 2 === 0" role="row">
              <td class="financial-year">
                <span class="year-badge bangla-text">{{tax.financial_year}}-{{tax.financial_year+1}}</span>
              </td>
              
              <td class="amount-cell">
                <span class="amount-badge bangla-text" [class.credit]="tax.debit_credit=='C'" [class.debit]="tax.debit_credit=='D'">
                  {{tax.debit_credit=='C'?'-':'+'}}{{tax.amount}} ৳
                </span>
              </td>
              
              <td class="type-cell">
                <span class="type-badge bangla-text" [class.credit]="tax.debit_credit=='C'" [class.debit]="tax.debit_credit=='D'">
                  {{tax.debit_credit=='C'?'বরাদ্দ':'আদায়'}}
                </span>
              </td>
              
              <td class="date-cell">
                <span class="mobile-number">{{tax.createdAt?.toString()?.substring(0,10)}}</span>
              </td>
              
              <td class="actions-cell">
                <div class="action-buttons-cell">
                  <button 
                    type="button"
                    title="ডিলিট করুন" 
                    class="btn-action-sm btn-danger"
                    (click)="deleteTax(tax.id)"
                    [attr.aria-label]="'মুছে ফেলুন'">
                    <i class="far fa-trash-alt" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>